import Phaser from 'phaser'

import MemoryGameScene from './scenes/MemoryGameScene'

const config = {
	type: Phaser.AUTO,
	width: 800,
	height: 600,
	physics: {
		default: 'arcade',
		
	},

	scale: {
		mode: Phaser.Scale.FIT,
		autoCenter: Phaser.Scale.CENTER_BOTH
		},

	scene: [MemoryGameScene]
}

export default new Phaser.Game(config)
